export default function QuickActions() {
    return (
      <div className="flex justify-between p-3 gap-2.5">
        {['HOT NUM', 'HEARING', 'TAPE 3', 'PROBABLES'].map((action) => (
          <button
            key={action}
            className="flex-1 bg-[#0E64D133] text-white py-0.5 rounded-full text-xs font-normal hover:bg-blue-700 transition-colors border border-[#ffffff]"
          >
            {action}
          </button>
        ))}
      </div>
    )
  }
  
  